import generate from "nanoid/generate.js";

const words = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

export default () => generate(words, 16);
